import React from "react"
import autobind from "class-autobind"
import { Card, CardHeader, CardText, CardActions } from "material-ui"
import { IWorkflowStep } from "../../models"
import WorkflowStepProgress from "./WorkflowStepProgress"
import TaskCard from "./TaskCard"
import { grey400 } from "material-ui/styles/colors"

interface IProps {
    step: IWorkflowStep
    onReload():void
}

interface IState {
}

export default class WorkflowStepCard extends React.Component<IProps, IState>  {
    constructor(props) {
        super(props)
        this.state = {
        }
        autobind(this)
    }

    render() {
        const completed = this.props.step.CompletedTaskCount === this.props.step.TotalTaskCount 
        const avitarUrl = this.props.step.CompletedTaskCount === this.props.step.TotalTaskCount ?
            "https://findd-prod-assets.s3.us-west-2.amazonaws.com/web/icon-assets/check-avitar.svg" :
            "https://findd-prod-assets.s3.us-west-2.amazonaws.com/web/icon-assets/working-avitar.svg"

        const title = `Step #${this.props.step.Order} ${this.props.step.Name}`
        const gradientColors = completed ? "linear-gradient(#C8E6C9, white)" : "linear-gradient(#BBDEFB, white)"
        
        return (
            <Card
                /*expanded={!completed}*/
            >
                <CardHeader
                    title={title}
                    subtitle={this.props.step.SubTitle}
                    actAsExpander={true}
                    showExpandableButton={true}
                    avatar={avitarUrl}
                />
                <CardActions style={{ paddingBottom: 20 }}>
                    <WorkflowStepProgress step={this.props.step} />
                </CardActions>
                <CardText expandable={true} style={{backgroundImage: gradientColors}}>
                    <div style={{ padding: 5}}>
                        {this.props.step.Tasks.map((item, index) =>
                            <div style={{ marginBottom: 20 }} key={index}><TaskCard task={item} key={index} onReload={this.props.onReload} /></div>
                        )}
                    </div>
                </CardText>
            </Card>
        )
    }
}